import * as selfConstants from './constants'

export const updateSelectedChannelIndex = payload => {
  return {
    type: selfConstants.SELECT_CHANNEL_INDEX,
    payload
  }
}
